import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import api from '../../config/api';

const VehicleRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('vehicleToken');
      
      if (!token) {
        setIsAuthenticated(false);
        setLoading(false);
        return;
      }

      try {
        // Verify the token by making a request to the protected endpoint
        await api.get('/vehicle/auth/me', {
          headers: { 'x-auth-token': token }
        });
        
        setIsAuthenticated(true);
      } catch (err) {
        console.error('Token verification error:', err);
        localStorage.removeItem('vehicleToken');
        localStorage.removeItem('vehicleUser');
        toast.error('Your session has expired. Please log in again.');
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    verifyToken();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/vehicle/login" />;
};

export default VehicleRoute;
